import { render, staticRenderFns } from "./WorkspaceLearnCanvasPanel.vue?vue&type=template&id=4ff0e91a&scoped=true"
import script from "./WorkspaceLearnCanvasPanel.vue?vue&type=script&lang=js"
export * from "./WorkspaceLearnCanvasPanel.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceLearnCanvasPanel.vue?vue&type=style&index=0&id=4ff0e91a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff0e91a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ff0e91a')) {
      api.createRecord('4ff0e91a', component.options)
    } else {
      api.reload('4ff0e91a', component.options)
    }
    module.hot.accept("./WorkspaceLearnCanvasPanel.vue?vue&type=template&id=4ff0e91a&scoped=true", function () {
      api.rerender('4ff0e91a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealKgWorkspace/WorkspaceLearnCanvasPanel.vue"
export default component.exports